<template>
  <div class="employer-info">
    <div class="basic">
      <p class="title">公司调研</p>
      <ul>
        <li>
          <span class="label">一句点评</span>
          <span class="text">{{ enterpriseSurveyDTO.oneComment || "-" }}</span>
        </li>
        <li>
          <span class="label">所属行业</span>
          <span
            class="text"
            v-if="
              enterpriseSurveyDTO.industryIds &&
                enterpriseSurveyDTO.industryIds.length
            "
            >{{ enterpriseSurveyDTO.industryIds | industry }}</span
          >
          <span class="text" v-else>-</span>
        </li>
        <li v-if="enterpriseSurveyDTO.info">
          <span class="label">公司简介</span>
          <span class="text">{{ enterpriseSurveyDTO.info }}</span>
        </li>
        <li v-if="enterpriseSurveyDTO.website">
          <span class="label">公司网址</span>
          <span class="text">{{ enterpriseSurveyDTO.website }}</span>
        </li>
        <li v-if="enterpriseSurveyDTO.styleNew">
          <span class="label">公司性质</span>
          <span class="text">{{ enterpriseSurveyDTO.styleNew }}</span>
        </li>
        <li>
          <span class="label">公司地址</span>
          <span class="text">
            <div
              v-if="
                enterpriseSurveyDTO.workLocations &&
                  enterpriseSurveyDTO.workLocations.length
              "
            >
              <p
                style="padding: 2px 0;"
                :key="index"
                v-for="(adr, index) in enterpriseSurveyDTO.workLocations"
              >
                <a
                  :href="
                    'http://api.map.baidu.com/marker?location=' +
                      (adr.provinceName +
                        adr.cityName +
                        (adr.address ? adr.address : '')) +
                      '&title=目标位置&content=' +
                      info.address +
                      '&output=html&src=webapp.baidu.openAPIdemo'
                  "
                  >{{
                    adr.provinceName +
                      adr.cityName +
                      (adr.address ? adr.address : "")
                  }}</a
                >
                <span class="company-main-tag" v-if="adr.type">{{
                  adr.type
                }}</span>
              </p>
            </div>
          </span>
        </li>
        <!-- <li v-if="info.addressDesc">
          <span class="label">工作地点</span>
          <span class="text">{{ info.addressDesc }}</span>
        </li> -->
        <li v-if="enterpriseSurveyDTO.establishYear > 0">
          <span class="label">成立年份</span>
          <span class="text">{{ enterpriseSurveyDTO.establishYear }}</span>
        </li>
        <li>
          <span class="label">发展阶段</span>
          <span class="text">
            <span>{{ enterpriseSurveyDTO.developStatus | developStatus }}</span>
            <span
              style="margin-left: 10px;"
              v-if="
                [2, 3, 4, 5, 6].includes(enterpriseSurveyDTO.developStatus) &&
                  enterpriseSurveyDTO.developAmount
              "
              >{{ enterpriseSurveyDTO.developAmount }}</span
            >
            <span
              style="margin-left: 10px;"
              v-if="
                enterpriseSurveyDTO.developStatus == 7 &&
                  enterpriseSurveyDTO.developPlate
              "
              >{{ enterpriseSurveyDTO.developPlate }}</span
            >
          </span>
        </li>
        <li>
          <span class="label">人员规模</span>
          <span
            class="text"
            v-if="enterpriseSurveyDTO.scale || enterpriseSurveyDTO.scale === 0"
            >{{ enterpriseSurveyDTO.scale | companyScale }}</span
          >
          <span class="text" v-else>-</span>
        </li>
        <li>
          <span class="label">主营产品</span>
          <span class="text">{{
            enterpriseSurveyDTO.mainManagement || "-"
          }}</span>
        </li>
        <li v-if="enterpriseSurveyDTO.salesScale">
          <span class="label">营收规模</span>
          <span class="text">{{ enterpriseSurveyDTO.salesScale || "-" }}</span>
        </li>
        <li v-if="enterpriseSurveyDTO.strategicalPlan">
          <span class="label">战略规划</span>
          <span class="text">{{
            enterpriseSurveyDTO.strategicalPlan || "-"
          }}</span>
        </li>
        <li v-if="enterpriseSurveyDTO.organizationStructure">
          <span class="label">组织架构</span>
          <span class="text">{{
            enterpriseSurveyDTO.organizationStructure || "-"
          }}</span>
        </li>
        <!-- <li>
          <span class="label">产业布局</span>
          <span class="text">{{
            enterpriseSurveyDTO.industrialPattern || "-"
          }}</span>
        </li> -->
        <li v-if="enterpriseSurveyDTO.socialSecurityBenefits">
          <span class="label">社保福利</span>
          <span class="text">{{
            enterpriseSurveyDTO.socialSecurityBenefits
              ? enterpriseSurveyDTO.socialSecurityBenefits
              : "-"
          }}</span>
        </li>

        <li v-if="enterpriseSurveyDTO.housingBenefits">
          <span class="label">住房福利</span>
          <span class="text">{{
            enterpriseSurveyDTO.housingBenefits || "-"
          }}</span>
        </li>
        <li v-if="enterpriseSurveyDTO.holidayBenefits">
          <span class="label">假期福利</span>
          <span class="text">{{
            enterpriseSurveyDTO.holidayBenefits
              ? enterpriseSurveyDTO.holidayBenefits
              : "-"
          }}</span>
        </li>
        <li v-if="enterpriseSurveyDTO.phoneTrafficBenefits">
          <span class="label">通讯交通</span>
          <span class="text">{{
            enterpriseSurveyDTO.phoneTrafficBenefits || "-"
          }}</span>
        </li>
        <li
          v-if="
            enterpriseSurveyDTO.workOverCost ||
              enterpriseSurveyDTO.workOverCostRule
          "
        >
          <span class="label">加班费用</span>
          <span class="text">
            <div
              v-if="
                enterpriseSurveyDTO.workOverCost ||
                  enterpriseSurveyDTO.workOverCostRule
              "
            >
              <p v-if="enterpriseSurveyDTO.workOverCost">
                <span>{{ enterpriseSurveyDTO.workOverCost }}</span>
              </p>
              <p v-if="enterpriseSurveyDTO.workOverCostRule">
                <span
                  >【加班费规则】{{
                    enterpriseSurveyDTO.workOverCostRule
                  }}</span
                >
              </p>
            </div>
            <div v-else>-</div>
          </span>
        </li>
        <li
          v-if="
            enterpriseSurveyDTO.wtMonthly ||
              enterpriseSurveyDTO.wtWorkOn ||
              enterpriseSurveyDTO.wtWorkOff ||
              enterpriseSurveyDTO.wtWorkRest ||
              enterpriseSurveyDTO.wtOverLevel
          "
        >
          <span class="label">工作时间</span>
          <span class="text">
            <div
              v-if="
                enterpriseSurveyDTO.wtMonthly ||
                  enterpriseSurveyDTO.wtWorkOn ||
                  enterpriseSurveyDTO.wtWorkOff ||
                  enterpriseSurveyDTO.wtWorkRest ||
                  enterpriseSurveyDTO.wtOverLevel
              "
            >
              <p v-if="enterpriseSurveyDTO.wtMonthly">
                <span>【月度情况】{{ enterpriseSurveyDTO.wtMonthly }}</span>
              </p>
              <p v-if="enterpriseSurveyDTO.wtWorkOn">
                <span>【上班时间】{{ enterpriseSurveyDTO.wtWorkOn }}</span>
              </p>
              <p v-if="enterpriseSurveyDTO.wtWorkOff">
                <span>【下班时间】{{ enterpriseSurveyDTO.wtWorkOff }}</span>
              </p>
              <p v-if="enterpriseSurveyDTO.wtWorkRest">
                <span>【午休时间】{{ enterpriseSurveyDTO.wtWorkRest }}</span>
              </p>
              <p v-if="enterpriseSurveyDTO.wtOverLevel">
                <span>【加班强度】{{ enterpriseSurveyDTO.wtOverLevel }}</span>
              </p>
            </div>
            <div v-else>-</div>
          </span>
        </li>
        <li
          v-if="
            enterpriseSurveyDTO.friendCompanys &&
              enterpriseSurveyDTO.friendCompanys.length
          "
        >
          <span class="label">友商名单</span>
          <span class="text">
            <div
              v-if="
                enterpriseSurveyDTO.friendCompanys &&
                  enterpriseSurveyDTO.friendCompanys.length
              "
            >
              <p
                :key="sv"
                v-for="sv in enterpriseSurveyDTO.friendCompanys.split(',')"
              >
                <span>{{ sv }}</span>
              </p>
            </div>
            <div v-else>-</div>
          </span>
        </li>
        <li
          v-if="
            enterpriseSurveyDTO.otherAttachs &&
              enterpriseSurveyDTO.otherAttachs.length
          "
        >
          <span class="label">相关附件</span>
          <span class="text">
            <div
              v-if="
                enterpriseSurveyDTO.otherAttachs &&
                  enterpriseSurveyDTO.otherAttachs.length
              "
            >
              <p
                :key="oa.fileName + '-' + index"
                v-for="(oa, index) in enterpriseSurveyDTO.otherAttachs"
              >
                <span>{{ oa.fileName }}</span>
              </p>
            </div>
            <div v-else>-</div>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "employerInfo",
  props: {
    info: {},
  },
  data() {
    return {
      iscover: false,
      needCover: false,
      loading: false,
      location: "",
    };
  },
  computed: {
    enterpriseSurveyDTO() {
      return this.info && this.info.enterpriseSurveyDTO
        ? this.info.enterpriseSurveyDTO
        : {};
    },
  },
  components: {},
  methods: {
    // setAddress(){
    //   let cityName = this.info.cityName || '';
    //   let address = this.info.address || '';
    //   let target  = cityName + address;
    //   const map = new BMap.Map("jMap");
    //   let myGeo = new BMap.Geocoder();
    //   myGeo.getPoint(target, (point)=>{
    //     if (point) {
    //       this.location = point.lat +','+ point.lng;
    //       map.centerAndZoom(point, 20);
    //       map.addOverlay(new BMap.Marker(point));
    //     }else{
    //     }
    //   }, cityName);
    // }
  },
  mounted() {},
  watch: {
    info(n, o) {
      this.$nextTick(() => {
        if (document.querySelector(".description .content")) {
          this.needCover =
            document.querySelector(".description .content").offsetHeight > 100;
          this.iscover = true;
        }
        // this.setAddress();
      });
    },
  },
  created() {},
};
</script>

<style scoped lang="scss">
.company-main-tag {
  width: 64px;
  height: 24px;
  line-height: 24px;
  background-color: rgba(245, 245, 245, 1);
  margin-left: 16px;
  text-align: center;
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  display: inline-block;
}

.employer-info {
  /*padding: 0 15px;*/
  background: #f5f5f5;
  .title {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    margin-bottom: 15px;
  }
  & > div {
    padding: 15px 15px;
    background: #fff;
  }
  .basic {
    ul {
      li {
        line-height: 20px;
        margin-bottom: 10px;
        display: flex;
        &:last-child {
          margin-bottom: 0;
        }
        span {
          &.label {
            margin-right: 20px;
            white-space: nowrap;
            font-size: 14px;
            color: #666666;
            width: 56px;
            text-align: justify;
            text-align-last: justify;
          }
          &.text {
            font-size: 14px;
            color: #333333;
            white-space: pre-line;
          }
        }
      }
    }
  }
  .description {
    border-top: 0.5px solid #e5e5e5;
    font-size: 14px;
    color: #666666;
    line-height: 25px;
    .content {
      white-space: pre-line;
      overflow: hidden;
      &.cover {
        max-height: 100px;
      }
    }
    .op {
      text-align: center;
      margin-top: 15px;
      i {
        margin-left: 5px;
      }
    }
  }
  .tag {
    margin-top: 10px;
    span {
      padding: 0 8px;
      margin-right: 10px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      margin-bottom: 10px;
      border: 0.5px solid #e5e5e5;
      font-size: 12px;
      color: #666;
      display: inline-block;
    }
  }
  .address {
    margin-top: 10px;
    .desc {
      color: #666;
    }
  }
}
</style>

<style lang="scss">
.employer-info {
  .j-map {
    width: 100%;
    height: 150px;
  }
  .address {
    .van-cell {
      padding-left: 0;
    }
  }
}
</style>
